import Helper from '@ember/component/helper';
import { htmlSafe } from '@ember/template';

export default class LegendStyle extends Helper {
  compute(params) {
    var color = params[0];
    return htmlSafe(`background-color: ${color}; border: 1px solid ${color}; box-shadow: 0 0 1px ${color};`);
  }
}
